import S360Link from "root/s360components/S360Link";
import {S360_urls} from "root/s360components/constants/S360_constants";
import DashboardSchoolAdminLinks from "root/s360components/DashboardSchoolAdminLinks";
import React, {Fragment} from "react";
import {ADMIN_USER_TYPES} from "root/s360components/AdminUsersDashboard";
import {UserTypes} from "root/globals";
import ConcernReportDashboardLink from "root/s360components/ConcernReportDashboardLink";

const AdminInternalLinks = ({school_id, user_id, user_type, permissionFlags}) =>
{

    const concernReportAccess = (concernReportsAccess) =>
    {
        const ENABLED = 'Y';

        return concernReportsAccess === ENABLED;
    }

    const permissions =
        {
            [ADMIN_USER_TYPES.SCHOOL_ADMIN]:
                {
                    access_dashboard: true,
                    my_pupils: false,
                    teacher_home: false,
                    register_class: true,
                    register_reports: true,
                    concern_reports: concernReportAccess(permissionFlags.concern_report_access),
                    my_account: true,
                    training_guide: false,
                    local_authority: true,
                    partnerships: true
                },
            [ADMIN_USER_TYPES.GOVERNOR]:
                {
                    access_dashboard: false,
                    my_pupils: false,
                    teacher_home: false,
                    register_class: false,
                    register_reports: false,
                    concern_reports: false,
                    my_account: false,
                    training_guide: false,
                    local_authority: false,
                    partnerships: false
                },
            [ADMIN_USER_TYPES.TEACHER]:
                {
                    access_dashboard: true,
                    my_pupils: true,
                    teacher_home: true,
                    register_class: true,
                    register_reports: true,
                    concern_reports: concernReportAccess(permissionFlags.concern_report_access),
                    my_account: true,
                    training_guide: true,
                    local_authority: false,
                    partnerships: false
                }
        };

    const buildMyAccountUrl = ( url ) =>
    {
        const user_type_int = {
            [ADMIN_USER_TYPES.TEACHER]: UserTypes.USER_TYPE_TEACHER,
            [ADMIN_USER_TYPES.SCHOOL_ADMIN]: UserTypes.USER_TYPE_SCHOOL_ADMIN,
            [ADMIN_USER_TYPES.GOVERNOR]: UserTypes.USER_TYPE_GOVERNOR,
        }

        return S360_urls.MY_ACCOUNT_URL + '&userId=' + user_id + '&user_type=' + user_type_int[user_type];
    }

    return (
        <Fragment>
            <div className='link-wrapper-internal'>
                {permissions[user_type].access_dashboard && <S360Link url={S360_urls.DASHBOARDS_URL} title='Access Dashboard' icon="glyphicon glyphicon-dashboard" school_id={school_id}/>}
                {permissions[user_type].my_pupils && <S360Link url={S360_urls.MY_PUPILS_URL} title='My Pupils' icon="glyphicon glyphicon-user"/>}
                {permissions[user_type].teacher_home && <S360Link url={S360_urls.TEACHER_HOME_URL} title='Teacher Home' icon='glyphicon glyphicon-home'/>}
                {permissions[user_type].register_class && <S360Link url={S360_urls.REGISTER_CLASS_URL} title='Register Class' icon="glyphicon glyphicon-list"/>}
                {permissions[user_type].register_reports && <S360Link url={S360_urls.REGISTRATION_REPORT_URL} title='Register Reports' icon="glyphicon glyphicon-file"/>}
                {permissions[user_type].concern_reports && <ConcernReportDashboardLink school_id={school_id}/>}
                {permissions[user_type].my_account && <S360Link url={buildMyAccountUrl()} title='My Account' icon="glyphicon glyphicon-cog"/>}
                {permissions[user_type].training_guide && <S360Link url={S360_urls.TRAINING_GUIDE_URL} target= '_blank' title='Training Guide' icon="glyphicon glyphicon-book"/>}
                {permissions[user_type].local_authority && permissions[user_type].partnerships && <DashboardSchoolAdminLinks school_id={school_id}/>}
            </div>
        </Fragment>
    )
}

export default AdminInternalLinks;